var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenCollapseIconInModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.516167,
    y: 0.516167,
    width: 35.9677,
    height: 35.9677,
    rx: 17.9838,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 -2.25624e-08 0.5)",
    fill: "#01A3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6902 20.5605L19.255 14.8269C19.1446 14.7104 19.0277 14.6268 18.9043 14.5761C18.7809 14.5254 18.6493 14.5 18.5094 14.5C18.3695 14.5 18.2379 14.5254 18.1145 14.5761C17.9911 14.6268 17.8742 14.7104 17.7638 14.8269L12.3098 20.5803C12.1033 20.7982 12 21.0637 12 21.3767C12 21.6897 12.1033 21.9552 12.3098 22.1731C12.5164 22.391 12.7712 22.4967 13.0742 22.4901C13.3772 22.4835 13.632 22.3713 13.8385 22.1533L18.5094 17.226L23.1989 22.1731C23.4055 22.391 23.6541 22.5 23.9446 22.5C24.2351 22.5 24.4836 22.391 24.6902 22.1731C24.8967 21.9552 25 21.6864 25 21.3668C25 21.0472 24.8967 20.7784 24.6902 20.5605Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.516167,
    y: 0.516167,
    width: 35.9677,
    height: 35.9677,
    rx: 17.9838,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 -2.25624e-08 0.5)",
    stroke: "white",
    strokeWidth: 1.03233
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCollapseIconInModal);
export default __webpack_public_path__ + "static/media/openCollapseIconInModal.c1c65c97.svg";
export { ForwardRef as ReactComponent };